// import React from 'react';
// import { QRCodeSVG } from 'qrcode.react';
// import certificateBg from '../../assets/certificates/dtech-template.png';
// import './CertificateTemplate.css';

// const CertificateTemplate = React.forwardRef(({ data, verifyBaseUrl }, ref) => {
//   const {
//     certId,
//     studentName,
//     branch,
//     course,
//     centre,
//     startDate,
//     endDate,
//     awardedOn,
//     certNo,
//   } = data;

//   const verifyUrl = `${verifyBaseUrl || window.location.origin}/verify/${certId}`;

//   return (
//     <div
//       className="cert-sheet"
//       ref={ref}
//       style={{ backgroundImage: `url(${certificateBg})` }}
//     >
//       <div className="cert-field cert-certno">{certNo}</div>
//       <div className="cert-field cert-awardedon">{awardedOn}</div>

//       <div className="cert-field cert-name">{studentName}</div>
//       <div className="cert-field cert-branch">{branch}</div>

//       <div className="cert-field cert-body">
//         has successfully completed an internship from <strong>{startDate}</strong> to{' '}
//         <strong>{endDate}</strong>, on <strong>{course}</strong> at <strong>DTECH</strong>{' '}
//         (Authorized CADDESK Centre) {centre}.
//       </div>

//       <div className="cert-qr-block">
//         <QRCodeSVG value={verifyUrl} size={90} />
//         <span className="cert-qr-caption">Scan to verify</span>
//       </div>
//     </div>
//   );
// });

// export default CertificateTemplate;


// import React from 'react';
// import { QRCodeSVG } from 'qrcode.react';
// import certificateBg from '../../assets/certificates/dtech.jpg';
// import './CertificateTemplate.css';

// const CertificateTemplate = React.forwardRef(({ data, verifyBaseUrl }, ref) => {
//   const {
//     certId,
//     studentName,
//     branch,
//     course,
//     centre,
//     startDate,
//     endDate,
//     awardedOn,
//     certNo,
//   } = data;

//   const verifyUrl = `${verifyBaseUrl || window.location.origin}/verify/${certId}`;

//   return (
//     <div
//       className="cert-sheet"
//       ref={ref}
//       style={{
//         position: 'relative',
//         width: '1493px',
//         height: '1057px',
//         minWidth: '1493px',
//         maxWidth: 'none',
//         flexShrink: 0,
//         backgroundImage: `url(${certificateBg})`,
//         backgroundSize: 'cover',
//         backgroundPosition: 'center',
//         backgroundRepeat: 'no-repeat',
//         backgroundColor: '#fff',
//         boxSizing: 'border-box',
//       }}
//     >
//    <div className="cert-field cert-certno">{certNo}</div>
//        <div className="cert-field cert-awardedon">{awardedOn}</div>
//       <div className="cert-field cert-name">{studentName}</div>
//       <div className="cert-field cert-branch">{branch}</div>
//       <div className="cert-field cert-body text-black">
//        <b> has successfully completed an internship from <strong>{startDate}</strong> to{' '}
//         <strong>{endDate}</strong>, on <strong>{course}</strong> at <strong>DTECH</strong>{' '}
//         (Authorized CADDESK Centre) {centre} Our comprehensive and high-quality
//          training program, delivered by well-experienced instructors using 
//          the latest technology, is available through a wide network of training centres. </b>
//       </div>
//       <div className="cert-qr-block">
//         <QRCodeSVG value={verifyUrl} size={150} />
//         <span className="cert-qr-caption">Scan to verify</span>
//       </div>
//     </div>
//   );
// });

// export default CertificateTemplate;


import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import certificateBg from '../../assets/certificates/dtech.jpg';
import './CertificateTemplate.css';

const formatDate = (dateStr) => {
  if (!dateStr) return dateStr;
  const parts = dateStr.split('-');
  if (parts.length !== 3) return dateStr;
  const [year, month, day] = parts;
  return `${day}-${month}-${year}`;
};

const CertificateTemplate = React.forwardRef(({ data, verifyBaseUrl }, ref) => {
  const {
    certId,
    studentName,
    branch,
    course,
    centre,
    startDate,
    endDate,
    awardedOn,
    certNo,
  } = data;

  const formattedStartDate = formatDate(startDate);
  const formattedEndDate = formatDate(endDate);
  const formattedAwardedOn = formatDate(awardedOn);

  const verifyUrl = `${verifyBaseUrl || window.location.origin}/verify/${certId}`;

  return (
    <div
      className="cert-sheet"
      ref={ref}
      style={{
        position: 'relative',
        width: '1493px',
        height: '1057px',
        minWidth: '1493px',
        maxWidth: 'none',
        flexShrink: 0,
        backgroundImage: `url(${certificateBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#fff',
        boxSizing: 'border-box',
      }}
    >
   <div className="cert-field cert-certno">{certNo}</div>
       <div className="cert-field cert-awardedon">{formattedAwardedOn}</div>
      <div className="cert-field cert-name">{studentName}</div>
      <div className="cert-field cert-branch">{branch}</div>
      <div className="cert-field cert-body text-black">
       <b> has successfully completed an internship from <strong>{formattedStartDate}</strong> to{' '}
        <strong>{formattedEndDate}</strong>, on <strong>{course}</strong> at <strong>DTECH</strong>{' '}
        (Authorized CADDESK Centre) {centre} Our comprehensive and high-quality
         training program, delivered by well-experienced instructors using 
         the latest technology, is available through a wide network of training centres. </b>
      </div>
      <div className="cert-qr-block">
        <QRCodeSVG value={verifyUrl} size={150} />
        <span className="cert-qr-caption">Scan to verify</span>
      </div>
    </div>
  );
});

export default CertificateTemplate;